var _rect, _line, _line2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _line3, _line4, _line5, _line6, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#0d1a2a"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 60,
    x2: 640,
    y2: 60,
    stroke: "#fff",
    strokeWidth: 0.4,
    opacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 300,
    x2: 640,
    y2: 300,
    stroke: "#fff",
    strokeWidth: 0.4,
    opacity: 0.05
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 180,
    r: 28,
    fill: "none",
    stroke: "#4a7a3a",
    strokeWidth: 1.5,
    opacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 180,
    r: 6,
    fill: "#4a7a3a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 120,
    r: 16,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 120,
    r: 4,
    fill: "#fff",
    opacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 120,
    r: 16,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 120,
    r: 4,
    fill: "#fff",
    opacity: 0.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 240,
    r: 16,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 240,
    r: 4,
    fill: "#fff",
    opacity: 0.4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 240,
    r: 16,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.3
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 240,
    r: 4,
    fill: "#fff",
    opacity: 0.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 196,
    y1: 128,
    x2: 293,
    y2: 170,
    stroke: "#4a7a3a",
    strokeWidth: 1,
    opacity: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 444,
    y1: 128,
    x2: 347,
    y2: 170,
    stroke: "#4a7a3a",
    strokeWidth: 1,
    opacity: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 196,
    y1: 232,
    x2: 293,
    y2: 190,
    stroke: "#4a7a3a",
    strokeWidth: 1,
    opacity: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 444,
    y1: 232,
    x2: 347,
    y2: 190,
    stroke: "#4a7a3a",
    strokeWidth: 1,
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 340,
    fontFamily: "Georgia, serif",
    fontSize: 10,
    fill: "#fff",
    opacity: 0.25,
    letterSpacing: 3
  }, "AGENT CONTROL PLANE \xB7 2026")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 42,
    fontFamily: "Georgia, serif",
    fontSize: 9,
    fill: "#4a7a3a",
    letterSpacing: 4
  }, "ONTOLOGY \xB7 WORKFLOW")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentCover);
export default __webpack_public_path__ + "static/media/agent-cover.30e45ce43c56043b99e1df587219018f.svg";
export { ForwardRef as ReactComponent };